import React, { useState } from "react";
import BlankState from "../Common/BlankState";
import TableFields from "../../constants/MerchantFacade/TableFields.json";
import styled from "styled-components";
import moment from "moment";
import Table from "../Common/Table";
import { getPath } from "../../utils";
import Delete from "sushiweb/Icons/all/Delete";
import { FlexContainer } from "../../constants/assets/containers";
import variables from "../../constants/assets/variables";
import ConfirmationModal from "../Common/ConfirmationModal";
import DriverDocumentModal from "../Common/DriverDocumentModal";
import MenuNames from "../../constants/Menu/MenuNames.json";
import MenuActionsMappings from "../../constants/Menu/MenuActionsMappings";
import Permission from "../Common/Permission";

const MerchantFacadeList = ({
  list,
  deleteMerchantFacadePictures,
  getMerchantFacadePictures,
  activeFilters,
  currentPage,
}) => {
  const [merchantId, setMerchantId] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const allActions = MenuActionsMappings[MenuNames.MERCHANT_FACADE_PIC];

  const handleDelete = (merchantId) => {
    setMerchantId(merchantId);
  };

  const handleImageClick = (url) => {
    setShowModal(true);
    setModalContent(url);
  };

  const confirmModalCloseHandler = () => {
    setMerchantId("");
  };

  const deleteRuleHandler = () => {
    deleteMerchantFacadePictures(merchantId).then(() => {
      setMerchantId("");
      const pageRequest = {
        page: currentPage,
        page_size: 10,
      };
      getMerchantFacadePictures(activeFilters, pageRequest);
    });
  };

  const handleClose = () => {
    setShowModal(false);
  };

  const getFieldValue = (item, key) => {
    if (key === "image_url") {
      return (
        <FlexContainer justify="flex-start" align="flex-start">
          <Image
            onClick={() => handleImageClick(item[key])}
            src={`${item[key]}`}
            alt=""
          />
          {!item["deleted_at"] && (
            <Permission requiredPerms={[allActions.DELETE]}>
              <Delete
                onClick={() => handleDelete(item["id"])}
                className="delete-icon"
                size={14}
                color={variables.primaryColor}
              />
            </Permission>
          )}
        </FlexContainer>
      );
    } else if (key === "is_deleted") {
      return item["deleted_at"] ? "Yes" : "No";
    } else if (
      key === "created_at" ||
      key === "updated_at" ||
      key === "deleted_at"
    ) {
      return item[key] ? moment(item[key]).format("DD/MM/YYYY hh:mm A") : "NA";
    } else {
      return item[key];
    }
  };

  return [
    getPath(list, "length", undefined) > 0 ? (
      <Table list={list} fields={TableFields} getFieldValue={getFieldValue} />
    ) : (
      <BlankState />
    ),
    <ConfirmationModal
      open={merchantId}
      modalTitle="Delete Facade Picture"
      onCofirmCancelHandler={confirmModalCloseHandler}
      onCofirmSuccessHandler={deleteRuleHandler}
      successButtonText="Yes"
      CancelButtonText="No"
    >
      {`Are you sure to delete the image?`}
    </ConfirmationModal>,
    <DriverDocumentModal
      showModal={showModal}
      handleClose={handleClose}
      modalContent={modalContent}
    />,
  ];
};

const Image = styled.img`
  padding: 2px;
  background-color: white;
  transition: transform .2s;
  margin-right: 4px;
  width: 100px;
  height: 100px;
  object-fit: cover;
  cursor: pointer !important;

  &:hover {
    transform: scale(2.5);
`;

export default MerchantFacadeList;
